<template>
  <svg
    :class="['app-icon', customClass]"
    :width="computedWidth"
    :height="computedHeight"
    aria-hidden="true"
    v-on="$listeners"
  >
    <use :xlink:href="`#icon-${name}`" :href="`#icon-${name}`" />
  </svg>
</template>

<script>
export default {
  name: "AppIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: null
    },
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: null
    },
    customClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    computedWidth() {
      if (this.width !== null && this.width !== undefined) return this.width;
      if (this.size !== null && this.size !== undefined) return this.size;
      return 20;
    },
    computedHeight() {
      if (this.height !== null && this.height !== undefined) return this.height;
      if (this.size !== null && this.size !== undefined) return this.size;
      return 20;
    }
  }
};
</script>

<style>
.app-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
